import state from "@/store/modules/category/state";
import actions from "@/store/modules/category/actions";
import mutations from "@/store/modules/category/mutations";
import getters from "@/store/modules/category/getters";

export default {
    state,
    actions,
    mutations,
    getters
}